import { render } from "./Board-of-Regents.vue?vue&type=template&id=1e20f87a&scoped=true"
import script from "./Board-of-Regents.vue?vue&type=script&lang=js"
export * from "./Board-of-Regents.vue?vue&type=script&lang=js"

import "./Board-of-Regents.vue?vue&type=style&index=0&id=1e20f87a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3853179034/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e20f87a"]])

export default __exports__